import CONSTANTS from '@/constants'
import api from './api'

// Promotion apis
const restaurants = {
	datatable(params) {
		return api.post(`${CONSTANTS.API_BASE_URL}/api/restaurant/datatable`, params)
	},
	store(params) {
		return api.post(`${CONSTANTS.API_BASE_URL}/api/restaurant/store`, params)
	},
	get(id) {
		return api.get(`${CONSTANTS.API_BASE_URL}/api/restaurant/${id}`)
	},
	update(id, formData) {
		formData.append('_method', 'PUT')

		return api.post(`${CONSTANTS.API_BASE_URL}/api/restaurant/${id}`, formData)
	},
	destroy(id) {
		return api.delete(`${CONSTANTS.API_BASE_URL}/api/restaurant/${id}`)
	},
}

export default restaurants
